import BaseResource from './BaseResource';

export default class ContentResource extends BaseResource {
  static urlRoot = '/api/v2/contents';

  id = '';

  type = '';

  attributes = {};

  position = 0;

  format = 'rich';

  pk() {
    return this.id;
  }
}



// WEBPACK FOOTER //
// ./app/javascript/client/resources/ContentResource.js